const formatDateWithTimezone = (dateString) => {
  const date = new Date(dateString)
  return date.toISOString()
}

export default formatDateWithTimezone
